import React from "react";
import "./Footer.css";
import Logo from "/Logo.png";
import { Youtube, Twitter, Linkedin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-top">
        {/* Logo */}
        <div className="footer-logo">
          <img src={Logo} alt="AI Squared Logo" className="footer-logo-img" />
        </div>

        {/* Navigation Columns */}
        <div className="footer-columns">
          <div className="footer-col">
            <h4>Product</h4>
            <a href="/agents">Features</a>
            <a href="/hotel">Pricing</a>
            <a href="/hotel">Book a demo</a>
          </div>

          <div className="footer-col">
            <h4>Sectors</h4>
            <a href="/hotel">Hotels &amp; Resorts</a>
            <a href="/agents">Restaurants</a>
            <a href="/agents">Spas &amp; Wellness</a>
            <a href="/agents">Clinics</a>
          </div>

          <div className="footer-col">
            <h4>Company</h4>
            <a href="/about">About us</a>
            <a href="/about">Contact us</a>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} AI Squared. All rights reserved.</p>

        <div className="footer-links">
          <a href="/about">Privacy Policy</a>
          <a href="/about">Terms of Service</a>
        </div>

        <div className="footer-socials">
          <a href="#"><Youtube size={18} /></a>
          <a href="#"><Twitter size={18} /></a>
          <a href="#"><Linkedin size={18} /></a>
        </div>
      </div>
    </footer>
  );
}
